// src/context/ThemeContext.js

import React, { createContext, useState } from 'react';

export const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState('day'); // Default theme is 'day'

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === 'day' ? 'night' : 'day'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}
